// Request bodies of the console writes a proposed step makes, in one place so
// the executor (server/src/services/action-executor.js) and the admin shadow
// panel's step previews (docs/agent-draft-shadow.md, 2026-10-23) build the
// same body from the same values. Pure: no calls.

// TRQ's POST /orders/{trqOrderId}/replacement body. notes is the note as it
// goes out (the executor adds the CXHub attribution line first); date is
// YYYY-MM-DD (the uniqueId's day); items are { sku, quantity } (a kit's
// component by its own SKU, never its kit).
export function buildReplacementRequestBody({ reasonCode, notes, shippingMethod, erpOrderId, date, address = {}, shippingPhone = null, items = [], salesPerson }) {
  const addr = address ?? {}
  return {
    returnReasonCode: String(reasonCode),
    notes,
    shippingMethod,
    uniqueId: `REP-${erpOrderId}-${reasonCode}-${date}`,
    address: {
      shippingName: addr.shippingName,
      shippingAddress1: addr.shippingAddress1,
      shippingAddress2: addr.shippingAddress2 ?? '',
      shippingPostalCode: addr.shippingPostalCode,
      shippingCity: addr.shippingCity,
      shippingCountry: 'US',
      shippingRegion: addr.shippingRegion,
      shippingPhone: shippingPhone ?? '',
    },
    items: (items ?? []).map((si) => ({ sku: si.sku, quantity: Number(si.quantity) || 1 })),
    attributes: [{ name: 'sales_person', value: salesPerson }],
  }
}

// TRQ's POST /orders/{erpOrderId}/notes body (actions.js's add_order_note).
export function buildOrderNoteRequestBody({ erpOrderId, notes }) {
  return { erpDocumentId: erpOrderId, importantNoteFlag: false, notes }
}

// The sales_person every CXHub TRQ write sends (action-executor.js's
// TEMP_SALES_PERSON).
export const CXHUB_SALES_PERSON = 'CXHUB-AUTOMATED'

// The "View call" of one shadow step preview with its current values
// (the preview's call: { service, method, url, kind, erpOrderId,
// shippingPhone }; values: { reasonCode, items, shippingMethod, address,
// note }). null when the step makes no call the preview can show. Never
// sent anywhere: the panel only shows it.
export function shadowStepCall(preview, values = {}, { date = new Date().toISOString().slice(0, 10) } = {}) {
  const call = preview?.call
  if (!call?.url) return null
  const v = values ?? {}
  if (call.kind === 'replacement') {
    return {
      service: call.service, method: call.method, url: call.url,
      body: buildReplacementRequestBody({
        reasonCode: v.reasonCode ?? '', notes: v.note ?? '', shippingMethod: v.shippingMethod ?? '', erpOrderId: call.erpOrderId, date,
        address: v.address ?? {}, shippingPhone: call.shippingPhone ?? null, items: v.items ?? [], salesPerson: CXHUB_SALES_PERSON,
      }),
    }
  }
  if (call.kind === 'order_note') {
    return { service: call.service, method: call.method, url: call.url, body: buildOrderNoteRequestBody({ erpOrderId: call.erpOrderId, notes: v.note ?? '' }) }
  }
  return null
}
